export default __webpack_public_path__ + "static/media/spinner.1885e261.png";